<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="selectManufacturer()">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field!='active'" class="wrapword">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active'">
          <p-checkbox style="margin: 2%;" id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="addNewManufacturer()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>


<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style.width]="'850px'" position="top" [baseZIndex]="10000"
  [contentStyle]="{'max-height':'85vh'}">
  <p-toast key="custom-toast" sticky="true"></p-toast>
  <div class="ui-inputgroup">
    <button pButton class="theme-button noHover labelButton mr-4 mb-2" type="button" label="Manufacturer Name"></button>
    <input  style="width:15.625rem;" placeholder="Enter Manufacturer Name" class="mb-2"
      id="manufacturerName" [(ngModel)]="selectedMasterList.manufacturerName" />
  </div>

  <div class="ui-inputgroup">
    <button pButton class="theme-button noHover labelButton mr-4 mb-2" type="button" label="Machine Type"></button>
    <p-dropdown *ngIf="typesOfMachines.length" [style]="{'width':'15.625rem'}" [options]="typesOfMachines"
      [(ngModel)]="selectedMasterList.machineType" placeholder="Select a Machine type"></p-dropdown>
  </div>
  <div class="ui-inputgroup">
    <button pButton class="theme-button noHover labelButton mr-4 mb-2 " type="button" label="Active"></button>
    <p-checkbox style="margin: 2%;" [(ngModel)]="selectedMasterList.active" [binary]="true"></p-checkbox>
  </div>
  <p-fieldset legend="Create File Pattern" toggleable="true" >
    <div>
      <div class="ui-inputgroup">
        <button pButton class="theme-button noHover labelButton mr-4 mb-2" type="button" label="Pattern"></button>
        <input  style="width:15.625rem;" placeholder="Enter Pattern" id="pattern" class="mb-2"
          [(ngModel)]="manufacturerConfig.pattern" />
      </div>
      <div class="ui-inputgroup">
        <button pButton class="theme-button noHover labelButton  mr-4 mb-2" type="button" label="Role of file"></button>
        <p-dropdown [style]="{'width':'28%'}" (onChange)="onChange($event)"
          [(ngModel)]="manufacturerConfig.roleOfFile" placeholder="Select a Role of file">
        </p-dropdown>
        <p-dropdown [style]="{'width':'28%'}" [disabled]="disabledProcessType"
          [(ngModel)]="manufacturerConfig.processType" placeholder="Select a Process type">
        </p-dropdown>
      </div>
      <div class="ui-inputgroup">
        <button pButton class="theme-button noHover labelButton mr-4 mb-2" type="button" label="Filetype"></button>
        <p-dropdown [style]="{'width':'15.625rem'}"
          [(ngModel)]="manufacturerConfig.fileType" placeholder="Select a File type"></p-dropdown>
        <div *ngIf="isCSVSelected(manufacturerConfig.fileType)">
          <p-dropdown class="ml-4" [style]="{'width':'120px', 'height': '34px'}" [options]="fileSeparators"
            [(ngModel)]="manufacturerConfig.fileSeparator" placeholder="file separator"></p-dropdown>
        </div>

      </div>
      <div class="ui-inputgroup">
        <button pButton class="theme-button noHover labelButton mr-4 mb-2" type="button" label="Mandatory"></button>
        <p-checkbox style="margin: 2%;" [disabled]="!disabledProcessType" [(ngModel)]="manufacturerConfig.mandatory" [binary]="true"></p-checkbox>
      </div>
    </div>
    <button class="buttonclass mt-2 float-right" type="button" [disabled]="checkCreatePattern()" pButton
      (click)="createPattern()" label="Create Pattern"></button>
  </p-fieldset>
  <div *ngIf="patternsForManufacturer.length>0">
    <div class="ui-inputgroup mt-3">
      <label class="font-weight-bold">Files that need to be uploaded :</label>
    </div>
    <div class="ui-g-12 p-0 pt-2 text-center">
      <p-table #table [value]="patternsForManufacturer" [columns]="patternCols" selectionMode='multiple'
        [(selection)]="selectedPatterns" [scrollable]="true" [loading]="loading" compareSelectionBy="equals">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.column" id="{{col.name}}" [attr.colspan]="col.colSpan">
              {{col.name}}
               <p-sortIcon [field]="col.column"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pattern>
          <tr [pSelectableRow]="pattern">
            <td colspan="2">
              {{pattern.pattern}}</td>
            <td>
              {{pattern.roleOfFile}}</td>
            <td>
              {{pattern.processType}}</td>
            <td>
              {{pattern.fileType}}</td>
            <td>
              {{pattern.fileSeparator}}</td>
            <td><em *ngIf="pattern.mandatory" class="fa fa-check" style="color:green"></em></td>
          </tr>
        </ng-template>
      </p-table>
      <div>
        <button type="button" [disabled]="selectedRows()" class="buttonclass mt-2 float-right" pButton
          (click)="deletePattern()" label="Delete Pattern"></button>
      </div>
    </div>
  </div>
  <button type="button" [disabled]="saveButtonDisable()" class="buttonclass float-right mt-4" pButton
    (click)="saveManufacturer()" label="Save" style="height: 35px;width: 20%;"></button>
</p-dialog>